import React from "react";
import logo from "../../assets/handiverse.png";
import writeLogo from "../../assets/Handiverse-white-logo.png";
import { BsTwitter } from "react-icons/bs";
import { AiFillInstagram } from "react-icons/ai";
import { Link } from "react-router-dom";

function Footer(props) {
  const handleOnClick = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="flex flex-col md:flex-row justify-between bg-[#0A0912] items-center z-40 p-10 md:px-[100px] lg:px-[200px] pb-30 2xl:px-[300px]">
      <div className="w-full">
        {" "}
        <div className="flex items-center mb-5 ">
          <img src={logo} className="" alt="" />
          <img src={writeLogo} alt="" />
        </div>
        <p className="text-[#494970] mt-2">
          &copy;2022 Handiverse. All rights reserved
        </p>
      </div>
      <div className="flex flex-col w-full md:w-5/12 ">
        <div className="lg:justify-end justify-start w-full md:justify-end flex">
          <Link
            onClick={handleOnClick}
            className="text-[#6E6EA1] md:mt-0 mt-3 mb-3"
            to="/terms-and-conditions"
          >
            Terms and Conditions
          </Link>
        </div>
        <div className="flex md:justify-end w-full  ">
          <a href="https://twitter.com/handiverseNFT">
            <BsTwitter
              className="hidden lg:block social-media-icon text-[#494970] ml-3 hover:text-white cursor-pointer "
              size={20}
            />
          </a>
          <a href="https://www.instagram.com/handiversenft/">
            {" "}
            <AiFillInstagram
              className="hidden lg:block social-media-icon text-[#494970] ml-3 hover:text-white cursor-pointer "
              size={20}
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
